import { useEffect, useMemo } from 'react';
import {
  useGetBonusesTransactions,
  useGetGame,
  useGetJackpots,
  useGetTransactions
} from 'react-easyrocket';
import { FIFTEEN_SECONDS } from 'src/constants';
import { useModalContext } from 'src/hooks/useModalContext';
import {
  getIntervalByJackpotProbability,
  jackpotGameIdTransactions,
  openJackpotModalFromBonusesTransactions,
  openJackpotModalFromTransactions
} from '../utils/jackpotModalUtils';
import { useGetGameId } from './useGetGameId';

export const useJackpotWin = () => {
  const { openModal } = useModalContext();
  const { jackpots } = useGetJackpots({}, { refetchInterval: FIFTEEN_SECONDS });
  const { gameId, isGamePage } = useGetGameId();

  const bonusesRefetchInterval = useMemo(
    () => getIntervalByJackpotProbability(jackpots),
    [jackpots]
  );
  const { arrayBonusesTansactions } = useGetBonusesTransactions(
    {
      bonus_type: 'All',
      status: ['Pending'],
      type: ['JackpotWin']
    },
    {
      isNeedPages: false,
      refetchInterval: bonusesRefetchInterval
    }
  );

  const { transactions } = useGetTransactions(
    {
      type: ['Jackpot']
    },
    { refetchInterval: bonusesRefetchInterval, target: 'type jackpot' }
  );

  const jackpotGameId = jackpotGameIdTransactions(transactions?.transactions) || 0;

  const { game, isLoading: isLoadingGame } = useGetGame(
    { game_id: gameId || jackpotGameId },
    { enabled: Boolean(gameId || jackpotGameId) }
  );

  useEffect(() => {
    openJackpotModalFromTransactions(transactions?.transactions, (jackpot) => {
      openModal('JACKPOTS_WIN', {
        props: { jackpot, game, isLoadingGame }
      });
    });
  }, [transactions]);

  useEffect(() => {
    openJackpotModalFromBonusesTransactions(arrayBonusesTansactions, (jackpot) => {
      openModal('JACKPOTS_WIN', {
        props: { jackpot, game, isLoadingGame }
      });
    });
  }, [arrayBonusesTansactions]);
};
